import client from './client';
import WebAPI from './api-calls';
import { getAccessToken } from './localstorage';
import { rateHandler } from './rate-handler';

const webApi = new WebAPI();

export async function fetchEnquiryFormStructure() {
    const response = await webApi.getFromWebApiWithAccessTokenAsync('/api/multiutility/enquiry-form-structure');
    return response.data;
}

export const recordSelfServeDeflection = (enquiryOptionDomainId) => {
    const task = async (res, rej) => {
        const bearerToken = getAccessToken();
        if (!bearerToken) {
            const error = { success: false, message: 'no_access_token' };
            return rej(error);
        }

        await client
            .post(
                '/api/multiutility/enquiry-deflections',
                { enquiryOptionDomainId },
                {
                    headers: {
                        Authorization: bearerToken,
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then((resp) => res({ success: true, data: resp.data }))
            .catch((err) => rej(err));
    };
    return rateHandler(task);
};

export const submitEnquiry = ({ enquiryOptionDomainId, description, submissionReference, siteDomainId, accountQuery }) => {
    const task = async (res, rej) => {
        const bearerToken = getAccessToken();
        if (!bearerToken) {
            const error = { success: false, message: 'no_access_token' };
            return rej(error);
        }

        await client
            .post(
                '/api/multiutility/enquiries',
                { enquiryOptionDomainId, description, submissionReference, siteDomainId, accountQuery },
                {
                    headers: {
                        Authorization: bearerToken,
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then((resp) => res({ success: true, data: resp.data }))
            .catch((err) => rej(err));
    };
    return rateHandler(task);
};
